import { Field, FieldWrapper } from "@progress/kendo-react-form";
import { useEffect, useCallback } from "react";
import EventFieldService from "../../../services/srv-event/EventFieldService";
import { FormInput } from "../../../components/sys-form/FormComponents";
import { requiredValidator } from "../../../components/sys-form/FormValidators";
import { t } from "i18next";

export const EventFormAdditionalInfo = ({
  formRenderProps,
  additionalFields,
  setAdditionalFields,
}) => {
  useEffect(() => {
    getFields();
  }, [formRenderProps.valueGetter("etkinliK_TIPI_KODU")]);

  useEffect(() => {
    populateFieldsFromJson();
  }, [additionalFields]);

  function getFields() {
    var etkinlikTipi = formRenderProps.valueGetter("etkinliK_TIPI_KODU");
    if (etkinlikTipi) {
      EventFieldService.getEventFields(etkinlikTipi).then((data) => {
        setAdditionalFields(data);
      });
    }
  }

  const populateFieldsFromJson = () => {
    if (additionalFields.length === 0) return;

    const existingJsonData = formRenderProps.valueGetter("eK_ALANLAR");

    if (existingJsonData) {
      try {
        const parsedData = JSON.parse(existingJsonData);

        additionalFields.forEach((field) => {
          const fieldValue = parsedData[field.alaN_KODU];
          if (fieldValue !== undefined && fieldValue !== null) {
            formRenderProps.onChange(field.alaN_KODU, {
              value: fieldValue,
            });
          }
        });
      } catch (error) {
        console.error("JSON parse hatası:", error);
      }
    }
  };

  const updateAdditionalFieldsJson = useCallback(
    (fields = additionalFields) => {
      const additionalData = {};

      fields.forEach((field) => {
        const value = formRenderProps.valueGetter(field.alaN_KODU);
        if (value !== undefined && value !== null && value !== "") {
          additionalData[field.alaN_KODU] = value;
        }
      });

      formRenderProps.onChange("eK_ALANLAR", {
        value: JSON.stringify(additionalData),
      });
    },
    [additionalFields, formRenderProps]
  );

  const handleFieldChange = (fieldCode, value) => {
    formRenderProps.onChange(fieldCode, { value });
    setTimeout(() => {
      updateAdditionalFieldsJson();
    }, 0);
  };

  useEffect(() => {
    if (additionalFields.length > 0) {
      updateAdditionalFieldsJson();
    }
  }, [additionalFields, updateAdditionalFieldsJson]);

  return (
    <div>
      {additionalFields.map((item, index) => (
        <FieldWrapper key={index}>
          <div className="k-form-field-wrap">
            <Field
              name={item.alaN_KODU}
              id={item.alaN_KODU}
              label={item.alaN_KODU_CEVIRI}
              component={FormInput}
              validator={(value) =>
                item.zorunlu === "EVET"
                  ? requiredValidator(value, t)
                  : undefined
              }
              onChange={(e) => handleFieldChange(item.alaN_KODU, e.value)}
            />
          </div>
        </FieldWrapper>
      ))}
    </div>
  );
};
